<template>
  <div>
    <vue-slideout-panel
      v-model="showInfoDialog"
      :widths="['40%']"
      close-html="<i class='fal fa-lg fa-times'></i>"
      @close="showInfoDialog = false"
    >
      <receipt-info
        :receipt-object="receiptInfo"
        @customer-selected="updateResults"
      />
    </vue-slideout-panel>

    <barcode-scanner @scan-init="scanBarcode" />
    <v-text-field
      v-if="includeSearch"
      ref="search"
      v-model="conditions.search"
      :label="$t('Search')"
      class="mb-6"
      filled
      hide-details
      prepend-inner-icon="far fa-search"
      single-line
    />

    <v-data-table
      :headers="headers"
      :items="receipts"
      :loading="$wait.is('fetching receipts')"
      :options.sync="pagination"
      :server-items-length="nrOfReceipts"
      v-bind="dataTableProps"
      sort-by="completed"
      sort-desc
    >
      <template v-slot:item="props">
        <tr
          :key="props.item.id"
          style="cursor: pointer"
          @click="showInfo(props.item)"
        >
          <td>{{ props.item.nr }}</td>
          <td>{{ _.get(props, 'item.store.name') }}</td>
          <td v-show="!customerObject">{{ _.get(props, 'item.customer.fullName', $t('Walk In')) }}</td>
          <td>{{ props.item.completed | moment("D MMMM YYYY H:mm") }}</td>
          <td>{{ props.item.totalInclVatRounded | money }}</td>
        </tr>
      </template>
    </v-data-table>
    <receipts-filter-speed-dial v-show="includeSpeedDial" />
  </div>
</template>

<script>
import receiptService from '@/services/receipts'
import camelcaseKeys from 'camelcase-keys'
import BarcodeScanner from '@/components/BarcodeScanner'
import StatusChip from '@/components/chips/StatusChip'
import ReceiptInfo from '@/components/receipts/ReceiptInfo'
import ReceiptsFilterSpeedDial from '@/components/receipts/ReceiptsFilterSpeedDial'
import { RECEIPT_COMPLETE } from '@/utils/statuses/receipt'
import _ from 'lodash'
import VueSlideoutPanel from 'vue-slideout-panel'
import { VDataTableDefaultProps as dataTableProps } from '@/utils/default-props/v-data-table'

export default {
  name: 'ReceiptsTable',

  components: {
    BarcodeScanner,
    StatusChip,
    ReceiptInfo,
    ReceiptsFilterSpeedDial,
    VueSlideoutPanel
  },

  props: {
    includeSearch: {
      default: false,
      type: Boolean
    },
    includeSpeedDial: {
      default: true,
      type: Boolean
    },
    receiptStatus: {
      default: RECEIPT_COMPLETE,
      type: Number,
      required: false
    },
    customerObject: {
      type: Object,
      required: false,
      default: null
    },
    productObject: {
      type: Object,
      required: false,
      default: null
    }
  },

  data () {
    return {
      headers: [
        {
          text: this.$t('Order Nr.'),
          value: 'Receipts.nr'
        },
        {
          text: this.$t('Store'),
          value: 'Stores.name'
        },
        {
          text: this.$t('Customer'),
          value: 'Customers.last_name',
          sortable: false,
          class: this.customerObject ? 'd-none' : ''
        },
        {
          text: this.$t('Date'),
          value: 'Receipts.created'
        },
        {
          text: this.$t('Total'),
          value: 'Receipts.total_incl_vat_rounded'
        }
      ],
      receipts: [],
      pagination: {},
      nrOfReceipts: 0,
      showInfoDialog: false,
      receiptInfo: null,
      customer: null,
      product: null,
      conditions: {},
      dataTableProps
    }
  },

  watch: {
    // update the customer data with updated customerObject (= prop)
    customerObject: {
      handler (customerObject) {
        if (customerObject) {
          this.resetToFirstPage()
        }
      }
    },
    productObject: {
      handler (productObject) {
        if (productObject) {
          this.resetToFirstPage()
        }
      }
    },
    // fetch receipts when requested page or sorting changed
    pagination (value) {
      this.updateResults()
    },
    // fetch receipts when search has changed
    'conditions.search': function (search) {
      this.updateResultsDebounced()
    }
  },

  methods: {
    scanBarcode (barcode) {
      this.$set(this.conditions, 'search', barcode)
    },
    updateResults () {
      this.$wait.start('fetching receipts')
      // reset dataset
      this.receipts = []

      this.$set(this.conditions, 'status', this.receiptStatus)
      if (this.customerObject) {
        this.$set(this.conditions, 'customerUuid', this.customerObject.uuid)
      }
      if (this.productObject) {
        this.$set(this.conditions, 'productId', this.productObject.id)
      }

      receiptService.pagination(this.conditions, this.pagination)
        .then((data) => {
          if (data.data) {
            this.receipts = camelcaseKeys(data.data.receipts, { deep: true })
            this.nrOfReceipts = data.data.total_count
          }
        })
        .finally((data) => this.$wait.end('fetching receipts'))
    },
    updateResultsDebounced: _.debounce(function () {
      this.updateResults()
    }, 500),
    showInfo (item) {
      this.receiptInfo = item
      this.showInfoDialog = true
    },
    resetToFirstPage () {
      if (this.pagination) {
        this.$set(this.pagination, 'page', 1)
        this.updateResults()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/receipts/ReceiptsTable.vue